import React from 'react';
import { Mail, MapPin, Linkedin, Github, Instagram } from 'lucide-react';
import { profileData } from '../data/mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const Contact = () => {
  return (
    <section id="contact" className="py-20 px-4 sm:px-6 lg:px-8 bg-muted/30">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-4 text-center">
          Get In Touch
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Have a project in mind or want to collaborate? Feel free to reach out!
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Contact Information */}
          <Card className="border-border">
            <CardHeader>
              <CardTitle className="text-lg">Contact Information</CardTitle>
              <CardDescription>Reach out through email or social media</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <div className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-primary mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Email</p>
                  <a
                    href={`mailto:${profileData.email}`}
                    className="text-sm text-muted-foreground hover:text-primary transition-colors"
                  >
                    {profileData.email}
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-primary mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-foreground mb-1">Location</p>
                  <p className="text-sm text-muted-foreground">{profileData.location}</p>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Direct Contact Card */}
          <Card className="border-border">
            <CardHeader>
              <CardTitle className="text-lg">Send Me an Email</CardTitle>
              <CardDescription>Click the button below to compose an email</CardDescription>
            </CardHeader>
            <CardContent className="space-y-6">
              <Button
                asChild
                size="lg"
                className="w-full"
              >
                <a href={`mailto:${profileData.email}`}>
                  <Mail className="h-4 w-4 mr-2" />
                  Compose Email
                </a>
              </Button>

              {/* Social Links */}
              <div>
                <p className="text-sm font-medium text-foreground mb-3">Connect on Social Media</p>
                <div className="flex gap-3">
                  <a
                    href={profileData.socialLinks.find(l => l.icon === 'linkedin')?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 rounded-lg bg-secondary hover:bg-primary hover:text-primary-foreground transition-colors"
                  >
                    <Linkedin className="h-5 w-5" />
                  </a>
                  <a
                    href={profileData.socialLinks.find(l => l.icon === 'github')?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 rounded-lg bg-secondary hover:bg-primary hover:text-primary-foreground transition-colors"
                  >
                    <Github className="h-5 w-5" />
                  </a>
                  <a
                    href={profileData.socialLinks.find(l => l.icon === 'instagram')?.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-10 h-10 rounded-lg bg-secondary hover:bg-primary hover:text-primary-foreground transition-colors"
                  >
                    <Instagram className="h-5 w-5" />
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default Contact;